export default __webpack_public_path__ + "static/media/refresh-icon.5fa01d8f.svg";